import lottie from 'lottie-web';

class PageNotFound extends HTMLElement {
  constructor() {
      super();
      this.animation = null; 

  }
  
  connectedCallback() {
    this.animation = lottie.loadAnimation({
      container: this,
      path: '/dist/lottie/window.json',
      renderer: 'svg',
      loop: false,
      autoplay: true,
      name: "Siden blev ikke fundet",
    });

  }

  disconnectedCallback() {
      // Add code to run when the component is removed from the DOM
  }

  attributeChangedCallback(name, oldValue, newValue) {
      // Add code to run when the component's attributes are changed
  }

}

customElements.define('nabohjaelp-pagenotfound', PageNotFound);